import React from "react";
import { CalendarClock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { track } from "@/lib/analytics";

const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL;

/**
 * "Programmer un appel" CTA. Renders only when REACT_APP_CALENDLY_URL is set.
 *
 * Variants:
 *   - "dark"   : light pill on dark backgrounds (Hero)
 *   - "light"  : dark pill on light backgrounds (QuoteForm intro / success state)
 *   - "outline": transparent border-only (secondary contexts)
 */
export default function CalendlyButton({
  variant = "light",
  size = "lg",
  label = "Programmer un appel",
  className = "",
  testId = "calendly-cta",
}) {
  if (!CALENDLY_URL) return null;

  const variants = {
    dark: "bg-stone-50 text-stone-900 hover:bg-orange-100",
    light: "bg-stone-900 text-stone-50 hover:bg-orange-800",
    outline:
      "border border-stone-300 bg-transparent text-stone-900 hover:bg-stone-100",
  };

  const handleClick = () => {
    track(
      "schedule_call_click",
      { source: testId },
      "Schedule",
      { content_name: "Calendly", source: testId }
    );
  };

  return (
    <a
      href={CALENDLY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      onClick={handleClick}
    >
      <Button
        size={size}
        className={`group h-12 rounded-full px-7 ${variants[variant]} ${className}`}
      >
        <CalendarClock
          className="mr-2 h-4 w-4 transition-transform group-hover:rotate-6"
          strokeWidth={1.5}
        />
        {label}
      </Button>
    </a>
  );
}
